export interface UserContactInfo {
  firstName: string;
  lastName: string;
  email: string;
}

export const mockUserData: UserContactInfo = {
  firstName: 'Kelly',
  lastName: 'Garmer',
  email: 'kelly.garmer@example.com',
};
